/**
 * SPA route: prefer `/#/path` so /about and legal pages work on static hosts
 * without Apache/nginx rewrites. Section links keep using `/#sectionId` (hash
 * does not start with `#/`).
 */
export function getClientRoute(): string {
  const hash = window.location.hash;
  if (hash.startsWith('#/')) {
    return hash.slice(1).replace(/\/+$/, '') || '/';
  }
  return window.location.pathname.replace(/\/+$/, '') || '/';
}
